module.exports = __webpack_public_path__ + "static/media/hasalon_thumb.a5b253bc.webp";